/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routing/__root'
import { Route as IndexRouteImport } from './routing/index'
import { Route as GymVenueUuidRouteImport } from './routing/gym.$venueUuid'
import { Route as GymVenueUuidIndexRouteImport } from './routing/gym.$venueUuid/index'
import { Route as GymVenueUuidStaffRouteImport } from './routing/gym.$venueUuid/staff'
import { Route as GymVenueUuidSettingsRouteImport } from './routing/gym.$venueUuid/settings'
import { Route as GymVenueUuidScheduleRouteImport } from './routing/gym.$venueUuid/schedule'
import { Route as GymVenueUuidRoutesRouteImport } from './routing/gym.$venueUuid/routes'
import { Route as GymVenueUuidLoyaltyRouteImport } from './routing/gym.$venueUuid/loyalty'
import { Route as GymVenueUuidScheduleIndexRouteImport } from './routing/gym.$venueUuid/schedule/index'
import { Route as GymVenueUuidRoutesIndexRouteImport } from './routing/gym.$venueUuid/routes/index'
import { Route as GymVenueUuidLoyaltyIndexRouteImport } from './routing/gym.$venueUuid/loyalty/index'
import { Route as GymVenueUuidEventsIndexRouteImport } from './routing/gym.$venueUuid/events/index'
import { Route as GymVenueUuidChallengesIndexRouteImport } from './routing/gym.$venueUuid/challenges/index'
import { Route as GymVenueUuidArchiveIndexRouteImport } from './routing/gym.$venueUuid/archive/index'
import { Route as GymVenueUuidStaffAddRouteImport } from './routing/gym.$venueUuid/staff.add'
import { Route as GymVenueUuidStaffUserUuidRouteImport } from './routing/gym.$venueUuid/staff.$userUuid'
import { Route as GymVenueUuidSettingsZonesRouteImport } from './routing/gym.$venueUuid/settings/zones'
import { Route as GymVenueUuidSettingsSectorsRouteImport } from './routing/gym.$venueUuid/settings/sectors'
import { Route as GymVenueUuidSettingsProfileRouteImport } from './routing/gym.$venueUuid/settings/profile'
import { Route as GymVenueUuidSettingsLinesRouteImport } from './routing/gym.$venueUuid/settings/lines'
import { Route as GymVenueUuidSettingsLabelsRouteImport } from './routing/gym.$venueUuid/settings/labels'
import { Route as GymVenueUuidSettingsCreditsRouteImport } from './routing/gym.$venueUuid/settings/credits'
import { Route as GymVenueUuidSettingsColorsRouteImport } from './routing/gym.$venueUuid/settings/colors'
import { Route as GymVenueUuidScheduleCalendarRouteImport } from './routing/gym.$venueUuid/schedule/calendar'
import { Route as GymVenueUuidRoutesClimbTypeRouteImport } from './routing/gym.$venueUuid/routes/$climbType'
import { Route as GymVenueUuidLoyaltyRewardsRouteImport } from './routing/gym.$venueUuid/loyalty/rewards'
import { Route as GymVenueUuidLoyaltyAccountsRouteImport } from './routing/gym.$venueUuid/loyalty/accounts'
import { Route as GymVenueUuidEventsCreateRouteImport } from './routing/gym.$venueUuid/events/create'
import { Route as GymVenueUuidEventsCompetitionUuidRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid'
import { Route as GymVenueUuidChallengesCreateRouteImport } from './routing/gym.$venueUuid/challenges/create'
import { Route as GymVenueUuidChallengesChallengeUuidRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid'
import { Route as GymVenueUuidArchiveClimbTypeRouteImport } from './routing/gym.$venueUuid/archive/$climbType'
import { Route as GymVenueUuidSettingsLabelsIndexRouteImport } from './routing/gym.$venueUuid/settings/labels.index'
import { Route as GymVenueUuidLoyaltyQuestsIndexRouteImport } from './routing/gym.$venueUuid/loyalty/quests/index'
import { Route as GymVenueUuidEventsCompetitionUuidIndexRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/index'
import { Route as GymVenueUuidChallengesChallengeUuidIndexRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/index'
import { Route as GymVenueUuidSettingsTargetsClimbTypeRouteImport } from './routing/gym.$venueUuid/settings/targets.$climbType'
import { Route as GymVenueUuidSettingsLinesCreateRouteImport } from './routing/gym.$venueUuid/settings/lines.create'
import { Route as GymVenueUuidSettingsLinesLineUuidRouteImport } from './routing/gym.$venueUuid/settings/lines.$lineUuid'
import { Route as GymVenueUuidSettingsLabelsArchiveRouteImport } from './routing/gym.$venueUuid/settings/labels.archive'
import { Route as GymVenueUuidScheduleSetSetUuidRouteImport } from './routing/gym.$venueUuid/schedule/set.$setUuid'
import { Route as GymVenueUuidRoutesClimbTypeCreateRouteImport } from './routing/gym.$venueUuid/routes/$climbType.create'
import { Route as GymVenueUuidLoyaltyRewardsCreateRouteImport } from './routing/gym.$venueUuid/loyalty/rewards/create'
import { Route as GymVenueUuidLoyaltyRewardsRewardUuidRouteImport } from './routing/gym.$venueUuid/loyalty/rewards/$rewardUuid'
import { Route as GymVenueUuidLoyaltyQuestsCreateRouteImport } from './routing/gym.$venueUuid/loyalty/quests/create'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid'
import { Route as GymVenueUuidLoyaltyAccountsAccountUuidRouteImport } from './routing/gym.$venueUuid/loyalty/accounts/$accountUuid'
import { Route as GymVenueUuidEventsSeriesCreateRouteImport } from './routing/gym.$venueUuid/events.series.create'
import { Route as GymVenueUuidEventsSeriesLeagueUuidRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid'
import { Route as GymVenueUuidEventsCompetitionUuidToolsRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/tools'
import { Route as GymVenueUuidEventsCompetitionUuidRoutesRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/routes'
import { Route as GymVenueUuidEventsCompetitionUuidProfileRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/profile'
import { Route as GymVenueUuidEventsCompetitionUuidCompetitorsRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/competitors'
import { Route as GymVenueUuidChallengesChallengeUuidToolsRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/tools'
import { Route as GymVenueUuidChallengesChallengeUuidProfileRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/profile'
import { Route as GymVenueUuidChallengesChallengeUuidEntriesRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/entries'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidIndexRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/index'
import { Route as GymVenueUuidEventsSeriesLeagueUuidIndexRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.index'
import { Route as GymVenueUuidEventsCompetitionUuidProfileIndexRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/profile.index'
import { Route as GymVenueUuidChallengesChallengeUuidProfileIndexRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/profile.index'
import { Route as GymVenueUuidSettingsTargetsClimbTypeTargetUuidRouteImport } from './routing/gym.$venueUuid/settings/targets.$climbType.$targetUuid'
import { Route as GymVenueUuidScheduleSetSetUuidEditRouteImport } from './routing/gym.$venueUuid/schedule/set.$setUuid.edit'
import { Route as GymVenueUuidScheduleSetSetUuidTaskUuidRouteImport } from './routing/gym.$venueUuid/schedule/set.$setUuid.$taskUuid'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/entries'
import { Route as GymVenueUuidEventsSeriesLeagueUuidProfileRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.profile'
import { Route as GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.competitors'
import { Route as GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/routes.$routeUuid'
import { Route as GymVenueUuidEventsCompetitionUuidProfileScoringRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/profile.scoring'
import { Route as GymVenueUuidEventsCompetitionUuidProfileDetailsRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/profile.details'
import { Route as GymVenueUuidEventsCompetitionUuidProfileCircuitsRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/profile.circuits'
import { Route as GymVenueUuidEventsCompetitionUuidProfileCategoriesRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/profile.categories'
import { Route as GymVenueUuidEventsCompetitionUuidCompetitorsCreateRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/competitors.create'
import { Route as GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRouteImport } from './routing/gym.$venueUuid/events/$competitionUuid/competitors.$userUuid'
import { Route as GymVenueUuidChallengesChallengeUuidProfileRulesRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/profile.rules'
import { Route as GymVenueUuidChallengesChallengeUuidProfilePromotionRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/profile.promotion'
import { Route as GymVenueUuidChallengesChallengeUuidProfileDetailsRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/profile.details'
import { Route as GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRouteImport } from './routing/gym.$venueUuid/challenges/$challengeUuid/entries.$entryUuid'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/profile.index'
import { Route as GymVenueUuidEventsSeriesLeagueUuidProfileIndexRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.profile.index'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/profile.rules'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/profile.promotion'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/profile.details'
import { Route as GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRouteImport } from './routing/gym.$venueUuid/loyalty/quests/$questUuid/entries.$entryUuid'
import { Route as GymVenueUuidEventsSeriesLeagueUuidProfileScoringRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.profile.scoring'
import { Route as GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.profile.details'
import { Route as GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.profile.categories'
import { Route as GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRouteImport } from './routing/gym.$venueUuid/events/series/$leagueUuid.competitors.$userUuid'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const GymVenueUuidRoute = GymVenueUuidRouteImport.update({
  id: '/gym/$venueUuid',
  path: '/gym/$venueUuid',
  getParentRoute: () => rootRouteImport,
} as any)
const GymVenueUuidIndexRoute = GymVenueUuidIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidStaffRoute = GymVenueUuidStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidSettingsRoute = GymVenueUuidSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidScheduleRoute = GymVenueUuidScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidRoutesRoute = GymVenueUuidRoutesRouteImport.update({
  id: '/routes',
  path: '/routes',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidLoyaltyRoute = GymVenueUuidLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidScheduleIndexRoute =
  GymVenueUuidScheduleIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidScheduleRoute,
  } as any)
const GymVenueUuidRoutesIndexRoute = GymVenueUuidRoutesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GymVenueUuidRoutesRoute,
} as any)
const GymVenueUuidLoyaltyIndexRoute =
  GymVenueUuidLoyaltyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidLoyaltyRoute,
  } as any)
const GymVenueUuidEventsIndexRoute = GymVenueUuidEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => GymVenueUuidRoute,
} as any)
const GymVenueUuidChallengesIndexRoute =
  GymVenueUuidChallengesIndexRouteImport.update({
    id: '/challenges/',
    path: '/challenges/',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidArchiveIndexRoute =
  GymVenueUuidArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidStaffAddRoute = GymVenueUuidStaffAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => GymVenueUuidStaffRoute,
} as any)
const GymVenueUuidStaffUserUuidRoute =
  GymVenueUuidStaffUserUuidRouteImport.update({
    id: '/$userUuid',
    path: '/$userUuid',
    getParentRoute: () => GymVenueUuidStaffRoute,
  } as any)
const GymVenueUuidSettingsZonesRoute =
  GymVenueUuidSettingsZonesRouteImport.update({
    id: '/zones',
    path: '/zones',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsSectorsRoute =
  GymVenueUuidSettingsSectorsRouteImport.update({
    id: '/sectors',
    path: '/sectors',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsProfileRoute =
  GymVenueUuidSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsLinesRoute =
  GymVenueUuidSettingsLinesRouteImport.update({
    id: '/lines',
    path: '/lines',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsLabelsRoute =
  GymVenueUuidSettingsLabelsRouteImport.update({
    id: '/labels',
    path: '/labels',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsCreditsRoute =
  GymVenueUuidSettingsCreditsRouteImport.update({
    id: '/credits',
    path: '/credits',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsColorsRoute =
  GymVenueUuidSettingsColorsRouteImport.update({
    id: '/colors',
    path: '/colors',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidScheduleCalendarRoute =
  GymVenueUuidScheduleCalendarRouteImport.update({
    id: '/calendar',
    path: '/calendar',
    getParentRoute: () => GymVenueUuidScheduleRoute,
  } as any)
const GymVenueUuidRoutesClimbTypeRoute =
  GymVenueUuidRoutesClimbTypeRouteImport.update({
    id: '/$climbType',
    path: '/$climbType',
    getParentRoute: () => GymVenueUuidRoutesRoute,
  } as any)
const GymVenueUuidLoyaltyRewardsRoute =
  GymVenueUuidLoyaltyRewardsRouteImport.update({
    id: '/rewards',
    path: '/rewards',
    getParentRoute: () => GymVenueUuidLoyaltyRoute,
  } as any)
const GymVenueUuidLoyaltyAccountsRoute =
  GymVenueUuidLoyaltyAccountsRouteImport.update({
    id: '/accounts',
    path: '/accounts',
    getParentRoute: () => GymVenueUuidLoyaltyRoute,
  } as any)
const GymVenueUuidEventsCreateRoute =
  GymVenueUuidEventsCreateRouteImport.update({
    id: '/events/create',
    path: '/events/create',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidRoute =
  GymVenueUuidEventsCompetitionUuidRouteImport.update({
    id: '/events/$competitionUuid',
    path: '/events/$competitionUuid',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidChallengesCreateRoute =
  GymVenueUuidChallengesCreateRouteImport.update({
    id: '/challenges/create',
    path: '/challenges/create',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidRoute =
  GymVenueUuidChallengesChallengeUuidRouteImport.update({
    id: '/challenges/$challengeUuid',
    path: '/challenges/$challengeUuid',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidArchiveClimbTypeRoute =
  GymVenueUuidArchiveClimbTypeRouteImport.update({
    id: '/archive/$climbType',
    path: '/archive/$climbType',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidSettingsLabelsIndexRoute =
  GymVenueUuidSettingsLabelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidSettingsLabelsRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsIndexRoute =
  GymVenueUuidLoyaltyQuestsIndexRouteImport.update({
    id: '/quests/',
    path: '/quests/',
    getParentRoute: () => GymVenueUuidLoyaltyRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidIndexRoute =
  GymVenueUuidEventsCompetitionUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidIndexRoute =
  GymVenueUuidChallengesChallengeUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidRoute,
  } as any)
const GymVenueUuidSettingsTargetsClimbTypeRoute =
  GymVenueUuidSettingsTargetsClimbTypeRouteImport.update({
    id: '/targets/$climbType',
    path: '/targets/$climbType',
    getParentRoute: () => GymVenueUuidSettingsRoute,
  } as any)
const GymVenueUuidSettingsLinesCreateRoute =
  GymVenueUuidSettingsLinesCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => GymVenueUuidSettingsLinesRoute,
  } as any)
const GymVenueUuidSettingsLinesLineUuidRoute =
  GymVenueUuidSettingsLinesLineUuidRouteImport.update({
    id: '/$lineUuid',
    path: '/$lineUuid',
    getParentRoute: () => GymVenueUuidSettingsLinesRoute,
  } as any)
const GymVenueUuidSettingsLabelsArchiveRoute =
  GymVenueUuidSettingsLabelsArchiveRouteImport.update({
    id: '/archive',
    path: '/archive',
    getParentRoute: () => GymVenueUuidSettingsLabelsRoute,
  } as any)
const GymVenueUuidScheduleSetSetUuidRoute =
  GymVenueUuidScheduleSetSetUuidRouteImport.update({
    id: '/set/$setUuid',
    path: '/set/$setUuid',
    getParentRoute: () => GymVenueUuidScheduleRoute,
  } as any)
const GymVenueUuidRoutesClimbTypeCreateRoute =
  GymVenueUuidRoutesClimbTypeCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => GymVenueUuidRoutesClimbTypeRoute,
  } as any)
const GymVenueUuidLoyaltyRewardsCreateRoute =
  GymVenueUuidLoyaltyRewardsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => GymVenueUuidLoyaltyRewardsRoute,
  } as any)
const GymVenueUuidLoyaltyRewardsRewardUuidRoute =
  GymVenueUuidLoyaltyRewardsRewardUuidRouteImport.update({
    id: '/$rewardUuid',
    path: '/$rewardUuid',
    getParentRoute: () => GymVenueUuidLoyaltyRewardsRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsCreateRoute =
  GymVenueUuidLoyaltyQuestsCreateRouteImport.update({
    id: '/quests/create',
    path: '/quests/create',
    getParentRoute: () => GymVenueUuidLoyaltyRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidRouteImport.update({
    id: '/quests/$questUuid',
    path: '/quests/$questUuid',
    getParentRoute: () => GymVenueUuidLoyaltyRoute,
  } as any)
const GymVenueUuidLoyaltyAccountsAccountUuidRoute =
  GymVenueUuidLoyaltyAccountsAccountUuidRouteImport.update({
    id: '/$accountUuid',
    path: '/$accountUuid',
    getParentRoute: () => GymVenueUuidLoyaltyAccountsRoute,
  } as any)
const GymVenueUuidEventsSeriesCreateRoute =
  GymVenueUuidEventsSeriesCreateRouteImport.update({
    id: '/events/series/create',
    path: '/events/series/create',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidRoute =
  GymVenueUuidEventsSeriesLeagueUuidRouteImport.update({
    id: '/events/series/$leagueUuid',
    path: '/events/series/$leagueUuid',
    getParentRoute: () => GymVenueUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidToolsRoute =
  GymVenueUuidEventsCompetitionUuidToolsRouteImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidRoutesRoute =
  GymVenueUuidEventsCompetitionUuidRoutesRouteImport.update({
    id: '/routes',
    path: '/routes',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidProfileRoute =
  GymVenueUuidEventsCompetitionUuidProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidCompetitorsRoute =
  GymVenueUuidEventsCompetitionUuidCompetitorsRouteImport.update({
    id: '/competitors',
    path: '/competitors',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidToolsRoute =
  GymVenueUuidChallengesChallengeUuidToolsRouteImport.update({
    id: '/tools',
    path: '/tools',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidProfileRoute =
  GymVenueUuidChallengesChallengeUuidProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidEntriesRoute =
  GymVenueUuidChallengesChallengeUuidEntriesRouteImport.update({
    id: '/entries',
    path: '/entries',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidIndexRoute =
  GymVenueUuidEventsSeriesLeagueUuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidProfileIndexRoute =
  GymVenueUuidEventsCompetitionUuidProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidProfileRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidProfileIndexRoute =
  GymVenueUuidChallengesChallengeUuidProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidProfileRoute,
  } as any)
const GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute =
  GymVenueUuidSettingsTargetsClimbTypeTargetUuidRouteImport.update({
    id: '/$targetUuid',
    path: '/$targetUuid',
    getParentRoute: () => GymVenueUuidSettingsTargetsClimbTypeRoute,
  } as any)
const GymVenueUuidScheduleSetSetUuidEditRoute =
  GymVenueUuidScheduleSetSetUuidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => GymVenueUuidScheduleSetSetUuidRoute,
  } as any)
const GymVenueUuidScheduleSetSetUuidTaskUuidRoute =
  GymVenueUuidScheduleSetSetUuidTaskUuidRouteImport.update({
    id: '/$taskUuid',
    path: '/$taskUuid',
    getParentRoute: () => GymVenueUuidScheduleSetSetUuidRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidEntriesRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteImport.update({
    id: '/entries',
    path: '/entries',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidProfileRoute =
  GymVenueUuidEventsSeriesLeagueUuidProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidCompetitorsRoute =
  GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteImport.update({
    id: '/competitors',
    path: '/competitors',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute =
  GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRouteImport.update({
    id: '/$routeUuid',
    path: '/$routeUuid',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidRoutesRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidProfileScoringRoute =
  GymVenueUuidEventsCompetitionUuidProfileScoringRouteImport.update({
    id: '/scoring',
    path: '/scoring',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidProfileRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidProfileDetailsRoute =
  GymVenueUuidEventsCompetitionUuidProfileDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidProfileRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute =
  GymVenueUuidEventsCompetitionUuidProfileCircuitsRouteImport.update({
    id: '/circuits',
    path: '/circuits',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidProfileRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute =
  GymVenueUuidEventsCompetitionUuidProfileCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidProfileRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute =
  GymVenueUuidEventsCompetitionUuidCompetitorsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidCompetitorsRoute,
  } as any)
const GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute =
  GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRouteImport.update({
    id: '/$userUuid',
    path: '/$userUuid',
    getParentRoute: () => GymVenueUuidEventsCompetitionUuidCompetitorsRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidProfileRulesRoute =
  GymVenueUuidChallengesChallengeUuidProfileRulesRouteImport.update({
    id: '/rules',
    path: '/rules',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidProfileRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidProfilePromotionRoute =
  GymVenueUuidChallengesChallengeUuidProfilePromotionRouteImport.update({
    id: '/promotion',
    path: '/promotion',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidProfileRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidProfileDetailsRoute =
  GymVenueUuidChallengesChallengeUuidProfileDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidProfileRoute,
  } as any)
const GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute =
  GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRouteImport.update({
    id: '/$entryUuid',
    path: '/$entryUuid',
    getParentRoute: () => GymVenueUuidChallengesChallengeUuidEntriesRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute =
  GymVenueUuidEventsSeriesLeagueUuidProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidProfileRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRouteImport.update({
    id: '/profile/rules',
    path: '/profile/rules',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRouteImport.update({
    id: '/profile/promotion',
    path: '/profile/promotion',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRouteImport.update({
    id: '/profile/details',
    path: '/profile/details',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidRoute,
  } as any)
const GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute =
  GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRouteImport.update({
    id: '/$entryUuid',
    path: '/$entryUuid',
    getParentRoute: () => GymVenueUuidLoyaltyQuestsQuestUuidEntriesRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute =
  GymVenueUuidEventsSeriesLeagueUuidProfileScoringRouteImport.update({
    id: '/scoring',
    path: '/scoring',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidProfileRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute =
  GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidProfileRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute =
  GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidProfileRoute,
  } as any)
const GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute =
  GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRouteImport.update({
    id: '/$userUuid',
    path: '/$userUuid',
    getParentRoute: () => GymVenueUuidEventsSeriesLeagueUuidCompetitorsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/gym/$venueUuid': typeof GymVenueUuidRouteWithChildren
  '/gym/$venueUuid/loyalty': typeof GymVenueUuidLoyaltyRouteWithChildren
  '/gym/$venueUuid/routes': typeof GymVenueUuidRoutesRouteWithChildren
  '/gym/$venueUuid/schedule': typeof GymVenueUuidScheduleRouteWithChildren
  '/gym/$venueUuid/settings': typeof GymVenueUuidSettingsRouteWithChildren
  '/gym/$venueUuid/staff': typeof GymVenueUuidStaffRouteWithChildren
  '/gym/$venueUuid/': typeof GymVenueUuidIndexRoute
  '/gym/$venueUuid/archive/$climbType': typeof GymVenueUuidArchiveClimbTypeRoute
  '/gym/$venueUuid/challenges/$challengeUuid': typeof GymVenueUuidChallengesChallengeUuidRouteWithChildren
  '/gym/$venueUuid/challenges/create': typeof GymVenueUuidChallengesCreateRoute
  '/gym/$venueUuid/events/$competitionUuid': typeof GymVenueUuidEventsCompetitionUuidRouteWithChildren
  '/gym/$venueUuid/events/create': typeof GymVenueUuidEventsCreateRoute
  '/gym/$venueUuid/loyalty/accounts': typeof GymVenueUuidLoyaltyAccountsRouteWithChildren
  '/gym/$venueUuid/loyalty/rewards': typeof GymVenueUuidLoyaltyRewardsRouteWithChildren
  '/gym/$venueUuid/routes/$climbType': typeof GymVenueUuidRoutesClimbTypeRouteWithChildren
  '/gym/$venueUuid/schedule/calendar': typeof GymVenueUuidScheduleCalendarRoute
  '/gym/$venueUuid/settings/colors': typeof GymVenueUuidSettingsColorsRoute
  '/gym/$venueUuid/settings/credits': typeof GymVenueUuidSettingsCreditsRoute
  '/gym/$venueUuid/settings/labels': typeof GymVenueUuidSettingsLabelsRouteWithChildren
  '/gym/$venueUuid/settings/lines': typeof GymVenueUuidSettingsLinesRouteWithChildren
  '/gym/$venueUuid/settings/profile': typeof GymVenueUuidSettingsProfileRoute
  '/gym/$venueUuid/settings/sectors': typeof GymVenueUuidSettingsSectorsRoute
  '/gym/$venueUuid/settings/zones': typeof GymVenueUuidSettingsZonesRoute
  '/gym/$venueUuid/staff/$userUuid': typeof GymVenueUuidStaffUserUuidRoute
  '/gym/$venueUuid/staff/add': typeof GymVenueUuidStaffAddRoute
  '/gym/$venueUuid/archive/': typeof GymVenueUuidArchiveIndexRoute
  '/gym/$venueUuid/challenges/': typeof GymVenueUuidChallengesIndexRoute
  '/gym/$venueUuid/events/': typeof GymVenueUuidEventsIndexRoute
  '/gym/$venueUuid/loyalty/': typeof GymVenueUuidLoyaltyIndexRoute
  '/gym/$venueUuid/routes/': typeof GymVenueUuidRoutesIndexRoute
  '/gym/$venueUuid/schedule/': typeof GymVenueUuidScheduleIndexRoute
  '/gym/$venueUuid/challenges/$challengeUuid/entries': typeof GymVenueUuidChallengesChallengeUuidEntriesRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/profile': typeof GymVenueUuidChallengesChallengeUuidProfileRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/tools': typeof GymVenueUuidChallengesChallengeUuidToolsRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors': typeof GymVenueUuidEventsCompetitionUuidCompetitorsRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/profile': typeof GymVenueUuidEventsCompetitionUuidProfileRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/routes': typeof GymVenueUuidEventsCompetitionUuidRoutesRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/tools': typeof GymVenueUuidEventsCompetitionUuidToolsRoute
  '/gym/$venueUuid/events/series/$leagueUuid': typeof GymVenueUuidEventsSeriesLeagueUuidRouteWithChildren
  '/gym/$venueUuid/events/series/create': typeof GymVenueUuidEventsSeriesCreateRoute
  '/gym/$venueUuid/loyalty/accounts/$accountUuid': typeof GymVenueUuidLoyaltyAccountsAccountUuidRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid': typeof GymVenueUuidLoyaltyQuestsQuestUuidRouteWithChildren
  '/gym/$venueUuid/loyalty/quests/create': typeof GymVenueUuidLoyaltyQuestsCreateRoute
  '/gym/$venueUuid/loyalty/rewards/$rewardUuid': typeof GymVenueUuidLoyaltyRewardsRewardUuidRoute
  '/gym/$venueUuid/loyalty/rewards/create': typeof GymVenueUuidLoyaltyRewardsCreateRoute
  '/gym/$venueUuid/routes/$climbType/create': typeof GymVenueUuidRoutesClimbTypeCreateRoute
  '/gym/$venueUuid/schedule/set/$setUuid': typeof GymVenueUuidScheduleSetSetUuidRouteWithChildren
  '/gym/$venueUuid/settings/labels/archive': typeof GymVenueUuidSettingsLabelsArchiveRoute
  '/gym/$venueUuid/settings/lines/$lineUuid': typeof GymVenueUuidSettingsLinesLineUuidRoute
  '/gym/$venueUuid/settings/lines/create': typeof GymVenueUuidSettingsLinesCreateRoute
  '/gym/$venueUuid/settings/targets/$climbType': typeof GymVenueUuidSettingsTargetsClimbTypeRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/': typeof GymVenueUuidChallengesChallengeUuidIndexRoute
  '/gym/$venueUuid/events/$competitionUuid/': typeof GymVenueUuidEventsCompetitionUuidIndexRoute
  '/gym/$venueUuid/loyalty/quests/': typeof GymVenueUuidLoyaltyQuestsIndexRoute
  '/gym/$venueUuid/settings/labels/': typeof GymVenueUuidSettingsLabelsIndexRoute
  '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid': typeof GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/details': typeof GymVenueUuidChallengesChallengeUuidProfileDetailsRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion': typeof GymVenueUuidChallengesChallengeUuidProfilePromotionRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/rules': typeof GymVenueUuidChallengesChallengeUuidProfileRulesRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid': typeof GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors/create': typeof GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/categories': typeof GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/circuits': typeof GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/details': typeof GymVenueUuidEventsCompetitionUuidProfileDetailsRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/scoring': typeof GymVenueUuidEventsCompetitionUuidProfileScoringRoute
  '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid': typeof GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute
  '/gym/$venueUuid/events/series/$leagueUuid/competitors': typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteWithChildren
  '/gym/$venueUuid/events/series/$leagueUuid/profile': typeof GymVenueUuidEventsSeriesLeagueUuidProfileRouteWithChildren
  '/gym/$venueUuid/loyalty/quests/$questUuid/entries': typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteWithChildren
  '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid': typeof GymVenueUuidScheduleSetSetUuidTaskUuidRoute
  '/gym/$venueUuid/schedule/set/$setUuid/edit': typeof GymVenueUuidScheduleSetSetUuidEditRoute
  '/gym/$venueUuid/settings/targets/$climbType/$targetUuid': typeof GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/': typeof GymVenueUuidChallengesChallengeUuidProfileIndexRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/': typeof GymVenueUuidEventsCompetitionUuidProfileIndexRoute
  '/gym/$venueUuid/events/series/$leagueUuid/': typeof GymVenueUuidEventsSeriesLeagueUuidIndexRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/': typeof GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute
  '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid': typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/categories': typeof GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/details': typeof GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring': typeof GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid': typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/': typeof GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/gym/$venueUuid/settings': typeof GymVenueUuidSettingsRouteWithChildren
  '/gym/$venueUuid/staff': typeof GymVenueUuidStaffRouteWithChildren
  '/gym/$venueUuid': typeof GymVenueUuidIndexRoute
  '/gym/$venueUuid/archive/$climbType': typeof GymVenueUuidArchiveClimbTypeRoute
  '/gym/$venueUuid/challenges/create': typeof GymVenueUuidChallengesCreateRoute
  '/gym/$venueUuid/events/create': typeof GymVenueUuidEventsCreateRoute
  '/gym/$venueUuid/loyalty/accounts': typeof GymVenueUuidLoyaltyAccountsRouteWithChildren
  '/gym/$venueUuid/loyalty/rewards': typeof GymVenueUuidLoyaltyRewardsRouteWithChildren
  '/gym/$venueUuid/routes/$climbType': typeof GymVenueUuidRoutesClimbTypeRouteWithChildren
  '/gym/$venueUuid/schedule/calendar': typeof GymVenueUuidScheduleCalendarRoute
  '/gym/$venueUuid/settings/colors': typeof GymVenueUuidSettingsColorsRoute
  '/gym/$venueUuid/settings/credits': typeof GymVenueUuidSettingsCreditsRoute
  '/gym/$venueUuid/settings/lines': typeof GymVenueUuidSettingsLinesRouteWithChildren
  '/gym/$venueUuid/settings/profile': typeof GymVenueUuidSettingsProfileRoute
  '/gym/$venueUuid/settings/sectors': typeof GymVenueUuidSettingsSectorsRoute
  '/gym/$venueUuid/settings/zones': typeof GymVenueUuidSettingsZonesRoute
  '/gym/$venueUuid/staff/$userUuid': typeof GymVenueUuidStaffUserUuidRoute
  '/gym/$venueUuid/staff/add': typeof GymVenueUuidStaffAddRoute
  '/gym/$venueUuid/archive': typeof GymVenueUuidArchiveIndexRoute
  '/gym/$venueUuid/challenges': typeof GymVenueUuidChallengesIndexRoute
  '/gym/$venueUuid/events': typeof GymVenueUuidEventsIndexRoute
  '/gym/$venueUuid/loyalty': typeof GymVenueUuidLoyaltyIndexRoute
  '/gym/$venueUuid/routes': typeof GymVenueUuidRoutesIndexRoute
  '/gym/$venueUuid/schedule': typeof GymVenueUuidScheduleIndexRoute
  '/gym/$venueUuid/challenges/$challengeUuid/entries': typeof GymVenueUuidChallengesChallengeUuidEntriesRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/tools': typeof GymVenueUuidChallengesChallengeUuidToolsRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors': typeof GymVenueUuidEventsCompetitionUuidCompetitorsRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/routes': typeof GymVenueUuidEventsCompetitionUuidRoutesRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/tools': typeof GymVenueUuidEventsCompetitionUuidToolsRoute
  '/gym/$venueUuid/events/series/create': typeof GymVenueUuidEventsSeriesCreateRoute
  '/gym/$venueUuid/loyalty/accounts/$accountUuid': typeof GymVenueUuidLoyaltyAccountsAccountUuidRoute
  '/gym/$venueUuid/loyalty/quests/create': typeof GymVenueUuidLoyaltyQuestsCreateRoute
  '/gym/$venueUuid/loyalty/rewards/$rewardUuid': typeof GymVenueUuidLoyaltyRewardsRewardUuidRoute
  '/gym/$venueUuid/loyalty/rewards/create': typeof GymVenueUuidLoyaltyRewardsCreateRoute
  '/gym/$venueUuid/routes/$climbType/create': typeof GymVenueUuidRoutesClimbTypeCreateRoute
  '/gym/$venueUuid/schedule/set/$setUuid': typeof GymVenueUuidScheduleSetSetUuidRouteWithChildren
  '/gym/$venueUuid/settings/labels/archive': typeof GymVenueUuidSettingsLabelsArchiveRoute
  '/gym/$venueUuid/settings/lines/$lineUuid': typeof GymVenueUuidSettingsLinesLineUuidRoute
  '/gym/$venueUuid/settings/lines/create': typeof GymVenueUuidSettingsLinesCreateRoute
  '/gym/$venueUuid/settings/targets/$climbType': typeof GymVenueUuidSettingsTargetsClimbTypeRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid': typeof GymVenueUuidChallengesChallengeUuidIndexRoute
  '/gym/$venueUuid/events/$competitionUuid': typeof GymVenueUuidEventsCompetitionUuidIndexRoute
  '/gym/$venueUuid/loyalty/quests': typeof GymVenueUuidLoyaltyQuestsIndexRoute
  '/gym/$venueUuid/settings/labels': typeof GymVenueUuidSettingsLabelsIndexRoute
  '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid': typeof GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/details': typeof GymVenueUuidChallengesChallengeUuidProfileDetailsRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion': typeof GymVenueUuidChallengesChallengeUuidProfilePromotionRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/rules': typeof GymVenueUuidChallengesChallengeUuidProfileRulesRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid': typeof GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors/create': typeof GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/categories': typeof GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/circuits': typeof GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/details': typeof GymVenueUuidEventsCompetitionUuidProfileDetailsRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/scoring': typeof GymVenueUuidEventsCompetitionUuidProfileScoringRoute
  '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid': typeof GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute
  '/gym/$venueUuid/events/series/$leagueUuid/competitors': typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteWithChildren
  '/gym/$venueUuid/loyalty/quests/$questUuid/entries': typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteWithChildren
  '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid': typeof GymVenueUuidScheduleSetSetUuidTaskUuidRoute
  '/gym/$venueUuid/schedule/set/$setUuid/edit': typeof GymVenueUuidScheduleSetSetUuidEditRoute
  '/gym/$venueUuid/settings/targets/$climbType/$targetUuid': typeof GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile': typeof GymVenueUuidChallengesChallengeUuidProfileIndexRoute
  '/gym/$venueUuid/events/$competitionUuid/profile': typeof GymVenueUuidEventsCompetitionUuidProfileIndexRoute
  '/gym/$venueUuid/events/series/$leagueUuid': typeof GymVenueUuidEventsSeriesLeagueUuidIndexRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid': typeof GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute
  '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid': typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/categories': typeof GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/details': typeof GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring': typeof GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid': typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile': typeof GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/gym/$venueUuid': typeof GymVenueUuidRouteWithChildren
  '/gym/$venueUuid/loyalty': typeof GymVenueUuidLoyaltyRouteWithChildren
  '/gym/$venueUuid/routes': typeof GymVenueUuidRoutesRouteWithChildren
  '/gym/$venueUuid/schedule': typeof GymVenueUuidScheduleRouteWithChildren
  '/gym/$venueUuid/settings': typeof GymVenueUuidSettingsRouteWithChildren
  '/gym/$venueUuid/staff': typeof GymVenueUuidStaffRouteWithChildren
  '/gym/$venueUuid/': typeof GymVenueUuidIndexRoute
  '/gym/$venueUuid/archive/$climbType': typeof GymVenueUuidArchiveClimbTypeRoute
  '/gym/$venueUuid/challenges/$challengeUuid': typeof GymVenueUuidChallengesChallengeUuidRouteWithChildren
  '/gym/$venueUuid/challenges/create': typeof GymVenueUuidChallengesCreateRoute
  '/gym/$venueUuid/events/$competitionUuid': typeof GymVenueUuidEventsCompetitionUuidRouteWithChildren
  '/gym/$venueUuid/events/create': typeof GymVenueUuidEventsCreateRoute
  '/gym/$venueUuid/loyalty/accounts': typeof GymVenueUuidLoyaltyAccountsRouteWithChildren
  '/gym/$venueUuid/loyalty/rewards': typeof GymVenueUuidLoyaltyRewardsRouteWithChildren
  '/gym/$venueUuid/routes/$climbType': typeof GymVenueUuidRoutesClimbTypeRouteWithChildren
  '/gym/$venueUuid/schedule/calendar': typeof GymVenueUuidScheduleCalendarRoute
  '/gym/$venueUuid/settings/colors': typeof GymVenueUuidSettingsColorsRoute
  '/gym/$venueUuid/settings/credits': typeof GymVenueUuidSettingsCreditsRoute
  '/gym/$venueUuid/settings/labels': typeof GymVenueUuidSettingsLabelsRouteWithChildren
  '/gym/$venueUuid/settings/lines': typeof GymVenueUuidSettingsLinesRouteWithChildren
  '/gym/$venueUuid/settings/profile': typeof GymVenueUuidSettingsProfileRoute
  '/gym/$venueUuid/settings/sectors': typeof GymVenueUuidSettingsSectorsRoute
  '/gym/$venueUuid/settings/zones': typeof GymVenueUuidSettingsZonesRoute
  '/gym/$venueUuid/staff/$userUuid': typeof GymVenueUuidStaffUserUuidRoute
  '/gym/$venueUuid/staff/add': typeof GymVenueUuidStaffAddRoute
  '/gym/$venueUuid/archive/': typeof GymVenueUuidArchiveIndexRoute
  '/gym/$venueUuid/challenges/': typeof GymVenueUuidChallengesIndexRoute
  '/gym/$venueUuid/events/': typeof GymVenueUuidEventsIndexRoute
  '/gym/$venueUuid/loyalty/': typeof GymVenueUuidLoyaltyIndexRoute
  '/gym/$venueUuid/routes/': typeof GymVenueUuidRoutesIndexRoute
  '/gym/$venueUuid/schedule/': typeof GymVenueUuidScheduleIndexRoute
  '/gym/$venueUuid/challenges/$challengeUuid/entries': typeof GymVenueUuidChallengesChallengeUuidEntriesRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/profile': typeof GymVenueUuidChallengesChallengeUuidProfileRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/tools': typeof GymVenueUuidChallengesChallengeUuidToolsRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors': typeof GymVenueUuidEventsCompetitionUuidCompetitorsRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/profile': typeof GymVenueUuidEventsCompetitionUuidProfileRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/routes': typeof GymVenueUuidEventsCompetitionUuidRoutesRouteWithChildren
  '/gym/$venueUuid/events/$competitionUuid/tools': typeof GymVenueUuidEventsCompetitionUuidToolsRoute
  '/gym/$venueUuid/events/series/$leagueUuid': typeof GymVenueUuidEventsSeriesLeagueUuidRouteWithChildren
  '/gym/$venueUuid/events/series/create': typeof GymVenueUuidEventsSeriesCreateRoute
  '/gym/$venueUuid/loyalty/accounts/$accountUuid': typeof GymVenueUuidLoyaltyAccountsAccountUuidRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid': typeof GymVenueUuidLoyaltyQuestsQuestUuidRouteWithChildren
  '/gym/$venueUuid/loyalty/quests/create': typeof GymVenueUuidLoyaltyQuestsCreateRoute
  '/gym/$venueUuid/loyalty/rewards/$rewardUuid': typeof GymVenueUuidLoyaltyRewardsRewardUuidRoute
  '/gym/$venueUuid/loyalty/rewards/create': typeof GymVenueUuidLoyaltyRewardsCreateRoute
  '/gym/$venueUuid/routes/$climbType/create': typeof GymVenueUuidRoutesClimbTypeCreateRoute
  '/gym/$venueUuid/schedule/set/$setUuid': typeof GymVenueUuidScheduleSetSetUuidRouteWithChildren
  '/gym/$venueUuid/settings/labels/archive': typeof GymVenueUuidSettingsLabelsArchiveRoute
  '/gym/$venueUuid/settings/lines/$lineUuid': typeof GymVenueUuidSettingsLinesLineUuidRoute
  '/gym/$venueUuid/settings/lines/create': typeof GymVenueUuidSettingsLinesCreateRoute
  '/gym/$venueUuid/settings/targets/$climbType': typeof GymVenueUuidSettingsTargetsClimbTypeRouteWithChildren
  '/gym/$venueUuid/challenges/$challengeUuid/': typeof GymVenueUuidChallengesChallengeUuidIndexRoute
  '/gym/$venueUuid/events/$competitionUuid/': typeof GymVenueUuidEventsCompetitionUuidIndexRoute
  '/gym/$venueUuid/loyalty/quests/': typeof GymVenueUuidLoyaltyQuestsIndexRoute
  '/gym/$venueUuid/settings/labels/': typeof GymVenueUuidSettingsLabelsIndexRoute
  '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid': typeof GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/details': typeof GymVenueUuidChallengesChallengeUuidProfileDetailsRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion': typeof GymVenueUuidChallengesChallengeUuidProfilePromotionRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/rules': typeof GymVenueUuidChallengesChallengeUuidProfileRulesRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid': typeof GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute
  '/gym/$venueUuid/events/$competitionUuid/competitors/create': typeof GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/categories': typeof GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/circuits': typeof GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/details': typeof GymVenueUuidEventsCompetitionUuidProfileDetailsRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/scoring': typeof GymVenueUuidEventsCompetitionUuidProfileScoringRoute
  '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid': typeof GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute
  '/gym/$venueUuid/events/series/$leagueUuid/competitors': typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteWithChildren
  '/gym/$venueUuid/events/series/$leagueUuid/profile': typeof GymVenueUuidEventsSeriesLeagueUuidProfileRouteWithChildren
  '/gym/$venueUuid/loyalty/quests/$questUuid/entries': typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteWithChildren
  '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid': typeof GymVenueUuidScheduleSetSetUuidTaskUuidRoute
  '/gym/$venueUuid/schedule/set/$setUuid/edit': typeof GymVenueUuidScheduleSetSetUuidEditRoute
  '/gym/$venueUuid/settings/targets/$climbType/$targetUuid': typeof GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute
  '/gym/$venueUuid/challenges/$challengeUuid/profile/': typeof GymVenueUuidChallengesChallengeUuidProfileIndexRoute
  '/gym/$venueUuid/events/$competitionUuid/profile/': typeof GymVenueUuidEventsCompetitionUuidProfileIndexRoute
  '/gym/$venueUuid/events/series/$leagueUuid/': typeof GymVenueUuidEventsSeriesLeagueUuidIndexRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/': typeof GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute
  '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid': typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/categories': typeof GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/details': typeof GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring': typeof GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid': typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute
  '/gym/$venueUuid/events/series/$leagueUuid/profile/': typeof GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute
  '/gym/$venueUuid/loyalty/quests/$questUuid/profile/': typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/gym/$venueUuid'
    | '/gym/$venueUuid/loyalty'
    | '/gym/$venueUuid/routes'
    | '/gym/$venueUuid/schedule'
    | '/gym/$venueUuid/settings'
    | '/gym/$venueUuid/staff'
    | '/gym/$venueUuid/'
    | '/gym/$venueUuid/archive/$climbType'
    | '/gym/$venueUuid/challenges/$challengeUuid'
    | '/gym/$venueUuid/challenges/create'
    | '/gym/$venueUuid/events/$competitionUuid'
    | '/gym/$venueUuid/events/create'
    | '/gym/$venueUuid/loyalty/accounts'
    | '/gym/$venueUuid/loyalty/rewards'
    | '/gym/$venueUuid/routes/$climbType'
    | '/gym/$venueUuid/schedule/calendar'
    | '/gym/$venueUuid/settings/colors'
    | '/gym/$venueUuid/settings/credits'
    | '/gym/$venueUuid/settings/labels'
    | '/gym/$venueUuid/settings/lines'
    | '/gym/$venueUuid/settings/profile'
    | '/gym/$venueUuid/settings/sectors'
    | '/gym/$venueUuid/settings/zones'
    | '/gym/$venueUuid/staff/$userUuid'
    | '/gym/$venueUuid/staff/add'
    | '/gym/$venueUuid/archive/'
    | '/gym/$venueUuid/challenges/'
    | '/gym/$venueUuid/events/'
    | '/gym/$venueUuid/loyalty/'
    | '/gym/$venueUuid/routes/'
    | '/gym/$venueUuid/schedule/'
    | '/gym/$venueUuid/challenges/$challengeUuid/entries'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile'
    | '/gym/$venueUuid/challenges/$challengeUuid/tools'
    | '/gym/$venueUuid/events/$competitionUuid/competitors'
    | '/gym/$venueUuid/events/$competitionUuid/profile'
    | '/gym/$venueUuid/events/$competitionUuid/routes'
    | '/gym/$venueUuid/events/$competitionUuid/tools'
    | '/gym/$venueUuid/events/series/$leagueUuid'
    | '/gym/$venueUuid/events/series/create'
    | '/gym/$venueUuid/loyalty/accounts/$accountUuid'
    | '/gym/$venueUuid/loyalty/quests/$questUuid'
    | '/gym/$venueUuid/loyalty/quests/create'
    | '/gym/$venueUuid/loyalty/rewards/$rewardUuid'
    | '/gym/$venueUuid/loyalty/rewards/create'
    | '/gym/$venueUuid/routes/$climbType/create'
    | '/gym/$venueUuid/schedule/set/$setUuid'
    | '/gym/$venueUuid/settings/labels/archive'
    | '/gym/$venueUuid/settings/lines/$lineUuid'
    | '/gym/$venueUuid/settings/lines/create'
    | '/gym/$venueUuid/settings/targets/$climbType'
    | '/gym/$venueUuid/challenges/$challengeUuid/'
    | '/gym/$venueUuid/events/$competitionUuid/'
    | '/gym/$venueUuid/loyalty/quests/'
    | '/gym/$venueUuid/settings/labels/'
    | '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/details'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/rules'
    | '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid'
    | '/gym/$venueUuid/events/$competitionUuid/competitors/create'
    | '/gym/$venueUuid/events/$competitionUuid/profile/categories'
    | '/gym/$venueUuid/events/$competitionUuid/profile/circuits'
    | '/gym/$venueUuid/events/$competitionUuid/profile/details'
    | '/gym/$venueUuid/events/$competitionUuid/profile/scoring'
    | '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/competitors'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/entries'
    | '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid'
    | '/gym/$venueUuid/schedule/set/$setUuid/edit'
    | '/gym/$venueUuid/settings/targets/$climbType/$targetUuid'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/'
    | '/gym/$venueUuid/events/$competitionUuid/profile/'
    | '/gym/$venueUuid/events/series/$leagueUuid/'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/'
    | '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/categories'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/details'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/gym/$venueUuid/settings'
    | '/gym/$venueUuid/staff'
    | '/gym/$venueUuid'
    | '/gym/$venueUuid/archive/$climbType'
    | '/gym/$venueUuid/challenges/create'
    | '/gym/$venueUuid/events/create'
    | '/gym/$venueUuid/loyalty/accounts'
    | '/gym/$venueUuid/loyalty/rewards'
    | '/gym/$venueUuid/routes/$climbType'
    | '/gym/$venueUuid/schedule/calendar'
    | '/gym/$venueUuid/settings/colors'
    | '/gym/$venueUuid/settings/credits'
    | '/gym/$venueUuid/settings/lines'
    | '/gym/$venueUuid/settings/profile'
    | '/gym/$venueUuid/settings/sectors'
    | '/gym/$venueUuid/settings/zones'
    | '/gym/$venueUuid/staff/$userUuid'
    | '/gym/$venueUuid/staff/add'
    | '/gym/$venueUuid/archive'
    | '/gym/$venueUuid/challenges'
    | '/gym/$venueUuid/events'
    | '/gym/$venueUuid/loyalty'
    | '/gym/$venueUuid/routes'
    | '/gym/$venueUuid/schedule'
    | '/gym/$venueUuid/challenges/$challengeUuid/entries'
    | '/gym/$venueUuid/challenges/$challengeUuid/tools'
    | '/gym/$venueUuid/events/$competitionUuid/competitors'
    | '/gym/$venueUuid/events/$competitionUuid/routes'
    | '/gym/$venueUuid/events/$competitionUuid/tools'
    | '/gym/$venueUuid/events/series/create'
    | '/gym/$venueUuid/loyalty/accounts/$accountUuid'
    | '/gym/$venueUuid/loyalty/quests/create'
    | '/gym/$venueUuid/loyalty/rewards/$rewardUuid'
    | '/gym/$venueUuid/loyalty/rewards/create'
    | '/gym/$venueUuid/routes/$climbType/create'
    | '/gym/$venueUuid/schedule/set/$setUuid'
    | '/gym/$venueUuid/settings/labels/archive'
    | '/gym/$venueUuid/settings/lines/$lineUuid'
    | '/gym/$venueUuid/settings/lines/create'
    | '/gym/$venueUuid/settings/targets/$climbType'
    | '/gym/$venueUuid/challenges/$challengeUuid'
    | '/gym/$venueUuid/events/$competitionUuid'
    | '/gym/$venueUuid/loyalty/quests'
    | '/gym/$venueUuid/settings/labels'
    | '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/details'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/rules'
    | '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid'
    | '/gym/$venueUuid/events/$competitionUuid/competitors/create'
    | '/gym/$venueUuid/events/$competitionUuid/profile/categories'
    | '/gym/$venueUuid/events/$competitionUuid/profile/circuits'
    | '/gym/$venueUuid/events/$competitionUuid/profile/details'
    | '/gym/$venueUuid/events/$competitionUuid/profile/scoring'
    | '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/competitors'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/entries'
    | '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid'
    | '/gym/$venueUuid/schedule/set/$setUuid/edit'
    | '/gym/$venueUuid/settings/targets/$climbType/$targetUuid'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile'
    | '/gym/$venueUuid/events/$competitionUuid/profile'
    | '/gym/$venueUuid/events/series/$leagueUuid'
    | '/gym/$venueUuid/loyalty/quests/$questUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/categories'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/details'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile'
  id:
    | '__root__'
    | '/'
    | '/gym/$venueUuid'
    | '/gym/$venueUuid/loyalty'
    | '/gym/$venueUuid/routes'
    | '/gym/$venueUuid/schedule'
    | '/gym/$venueUuid/settings'
    | '/gym/$venueUuid/staff'
    | '/gym/$venueUuid/'
    | '/gym/$venueUuid/archive/$climbType'
    | '/gym/$venueUuid/challenges/$challengeUuid'
    | '/gym/$venueUuid/challenges/create'
    | '/gym/$venueUuid/events/$competitionUuid'
    | '/gym/$venueUuid/events/create'
    | '/gym/$venueUuid/loyalty/accounts'
    | '/gym/$venueUuid/loyalty/rewards'
    | '/gym/$venueUuid/routes/$climbType'
    | '/gym/$venueUuid/schedule/calendar'
    | '/gym/$venueUuid/settings/colors'
    | '/gym/$venueUuid/settings/credits'
    | '/gym/$venueUuid/settings/labels'
    | '/gym/$venueUuid/settings/lines'
    | '/gym/$venueUuid/settings/profile'
    | '/gym/$venueUuid/settings/sectors'
    | '/gym/$venueUuid/settings/zones'
    | '/gym/$venueUuid/staff/$userUuid'
    | '/gym/$venueUuid/staff/add'
    | '/gym/$venueUuid/archive/'
    | '/gym/$venueUuid/challenges/'
    | '/gym/$venueUuid/events/'
    | '/gym/$venueUuid/loyalty/'
    | '/gym/$venueUuid/routes/'
    | '/gym/$venueUuid/schedule/'
    | '/gym/$venueUuid/challenges/$challengeUuid/entries'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile'
    | '/gym/$venueUuid/challenges/$challengeUuid/tools'
    | '/gym/$venueUuid/events/$competitionUuid/competitors'
    | '/gym/$venueUuid/events/$competitionUuid/profile'
    | '/gym/$venueUuid/events/$competitionUuid/routes'
    | '/gym/$venueUuid/events/$competitionUuid/tools'
    | '/gym/$venueUuid/events/series/$leagueUuid'
    | '/gym/$venueUuid/events/series/create'
    | '/gym/$venueUuid/loyalty/accounts/$accountUuid'
    | '/gym/$venueUuid/loyalty/quests/$questUuid'
    | '/gym/$venueUuid/loyalty/quests/create'
    | '/gym/$venueUuid/loyalty/rewards/$rewardUuid'
    | '/gym/$venueUuid/loyalty/rewards/create'
    | '/gym/$venueUuid/routes/$climbType/create'
    | '/gym/$venueUuid/schedule/set/$setUuid'
    | '/gym/$venueUuid/settings/labels/archive'
    | '/gym/$venueUuid/settings/lines/$lineUuid'
    | '/gym/$venueUuid/settings/lines/create'
    | '/gym/$venueUuid/settings/targets/$climbType'
    | '/gym/$venueUuid/challenges/$challengeUuid/'
    | '/gym/$venueUuid/events/$competitionUuid/'
    | '/gym/$venueUuid/loyalty/quests/'
    | '/gym/$venueUuid/settings/labels/'
    | '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/details'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/rules'
    | '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid'
    | '/gym/$venueUuid/events/$competitionUuid/competitors/create'
    | '/gym/$venueUuid/events/$competitionUuid/profile/categories'
    | '/gym/$venueUuid/events/$competitionUuid/profile/circuits'
    | '/gym/$venueUuid/events/$competitionUuid/profile/details'
    | '/gym/$venueUuid/events/$competitionUuid/profile/scoring'
    | '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/competitors'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/entries'
    | '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid'
    | '/gym/$venueUuid/schedule/set/$setUuid/edit'
    | '/gym/$venueUuid/settings/targets/$climbType/$targetUuid'
    | '/gym/$venueUuid/challenges/$challengeUuid/profile/'
    | '/gym/$venueUuid/events/$competitionUuid/profile/'
    | '/gym/$venueUuid/events/series/$leagueUuid/'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/'
    | '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/categories'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/details'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules'
    | '/gym/$venueUuid/events/series/$leagueUuid/profile/'
    | '/gym/$venueUuid/loyalty/quests/$questUuid/profile/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  GymVenueUuidRoute: typeof GymVenueUuidRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gym/$venueUuid': {
      id: '/gym/$venueUuid'
      path: '/gym/$venueUuid'
      fullPath: '/gym/$venueUuid'
      preLoaderRoute: typeof GymVenueUuidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gym/$venueUuid/': {
      id: '/gym/$venueUuid/'
      path: '/'
      fullPath: '/gym/$venueUuid/'
      preLoaderRoute: typeof GymVenueUuidIndexRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/staff': {
      id: '/gym/$venueUuid/staff'
      path: '/staff'
      fullPath: '/gym/$venueUuid/staff'
      preLoaderRoute: typeof GymVenueUuidStaffRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/settings': {
      id: '/gym/$venueUuid/settings'
      path: '/settings'
      fullPath: '/gym/$venueUuid/settings'
      preLoaderRoute: typeof GymVenueUuidSettingsRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/schedule': {
      id: '/gym/$venueUuid/schedule'
      path: '/schedule'
      fullPath: '/gym/$venueUuid/schedule'
      preLoaderRoute: typeof GymVenueUuidScheduleRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/routes': {
      id: '/gym/$venueUuid/routes'
      path: '/routes'
      fullPath: '/gym/$venueUuid/routes'
      preLoaderRoute: typeof GymVenueUuidRoutesRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/loyalty': {
      id: '/gym/$venueUuid/loyalty'
      path: '/loyalty'
      fullPath: '/gym/$venueUuid/loyalty'
      preLoaderRoute: typeof GymVenueUuidLoyaltyRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/schedule/': {
      id: '/gym/$venueUuid/schedule/'
      path: '/'
      fullPath: '/gym/$venueUuid/schedule/'
      preLoaderRoute: typeof GymVenueUuidScheduleIndexRouteImport
      parentRoute: typeof GymVenueUuidScheduleRoute
    }
    '/gym/$venueUuid/routes/': {
      id: '/gym/$venueUuid/routes/'
      path: '/'
      fullPath: '/gym/$venueUuid/routes/'
      preLoaderRoute: typeof GymVenueUuidRoutesIndexRouteImport
      parentRoute: typeof GymVenueUuidRoutesRoute
    }
    '/gym/$venueUuid/loyalty/': {
      id: '/gym/$venueUuid/loyalty/'
      path: '/'
      fullPath: '/gym/$venueUuid/loyalty/'
      preLoaderRoute: typeof GymVenueUuidLoyaltyIndexRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRoute
    }
    '/gym/$venueUuid/events/': {
      id: '/gym/$venueUuid/events/'
      path: '/events'
      fullPath: '/gym/$venueUuid/events/'
      preLoaderRoute: typeof GymVenueUuidEventsIndexRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/challenges/': {
      id: '/gym/$venueUuid/challenges/'
      path: '/challenges'
      fullPath: '/gym/$venueUuid/challenges/'
      preLoaderRoute: typeof GymVenueUuidChallengesIndexRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/archive/': {
      id: '/gym/$venueUuid/archive/'
      path: '/archive'
      fullPath: '/gym/$venueUuid/archive/'
      preLoaderRoute: typeof GymVenueUuidArchiveIndexRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/staff/add': {
      id: '/gym/$venueUuid/staff/add'
      path: '/add'
      fullPath: '/gym/$venueUuid/staff/add'
      preLoaderRoute: typeof GymVenueUuidStaffAddRouteImport
      parentRoute: typeof GymVenueUuidStaffRoute
    }
    '/gym/$venueUuid/staff/$userUuid': {
      id: '/gym/$venueUuid/staff/$userUuid'
      path: '/$userUuid'
      fullPath: '/gym/$venueUuid/staff/$userUuid'
      preLoaderRoute: typeof GymVenueUuidStaffUserUuidRouteImport
      parentRoute: typeof GymVenueUuidStaffRoute
    }
    '/gym/$venueUuid/settings/zones': {
      id: '/gym/$venueUuid/settings/zones'
      path: '/zones'
      fullPath: '/gym/$venueUuid/settings/zones'
      preLoaderRoute: typeof GymVenueUuidSettingsZonesRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/sectors': {
      id: '/gym/$venueUuid/settings/sectors'
      path: '/sectors'
      fullPath: '/gym/$venueUuid/settings/sectors'
      preLoaderRoute: typeof GymVenueUuidSettingsSectorsRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/profile': {
      id: '/gym/$venueUuid/settings/profile'
      path: '/profile'
      fullPath: '/gym/$venueUuid/settings/profile'
      preLoaderRoute: typeof GymVenueUuidSettingsProfileRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/lines': {
      id: '/gym/$venueUuid/settings/lines'
      path: '/lines'
      fullPath: '/gym/$venueUuid/settings/lines'
      preLoaderRoute: typeof GymVenueUuidSettingsLinesRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/labels': {
      id: '/gym/$venueUuid/settings/labels'
      path: '/labels'
      fullPath: '/gym/$venueUuid/settings/labels'
      preLoaderRoute: typeof GymVenueUuidSettingsLabelsRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/credits': {
      id: '/gym/$venueUuid/settings/credits'
      path: '/credits'
      fullPath: '/gym/$venueUuid/settings/credits'
      preLoaderRoute: typeof GymVenueUuidSettingsCreditsRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/colors': {
      id: '/gym/$venueUuid/settings/colors'
      path: '/colors'
      fullPath: '/gym/$venueUuid/settings/colors'
      preLoaderRoute: typeof GymVenueUuidSettingsColorsRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/schedule/calendar': {
      id: '/gym/$venueUuid/schedule/calendar'
      path: '/calendar'
      fullPath: '/gym/$venueUuid/schedule/calendar'
      preLoaderRoute: typeof GymVenueUuidScheduleCalendarRouteImport
      parentRoute: typeof GymVenueUuidScheduleRoute
    }
    '/gym/$venueUuid/routes/$climbType': {
      id: '/gym/$venueUuid/routes/$climbType'
      path: '/$climbType'
      fullPath: '/gym/$venueUuid/routes/$climbType'
      preLoaderRoute: typeof GymVenueUuidRoutesClimbTypeRouteImport
      parentRoute: typeof GymVenueUuidRoutesRoute
    }
    '/gym/$venueUuid/loyalty/rewards': {
      id: '/gym/$venueUuid/loyalty/rewards'
      path: '/rewards'
      fullPath: '/gym/$venueUuid/loyalty/rewards'
      preLoaderRoute: typeof GymVenueUuidLoyaltyRewardsRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRoute
    }
    '/gym/$venueUuid/loyalty/accounts': {
      id: '/gym/$venueUuid/loyalty/accounts'
      path: '/accounts'
      fullPath: '/gym/$venueUuid/loyalty/accounts'
      preLoaderRoute: typeof GymVenueUuidLoyaltyAccountsRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRoute
    }
    '/gym/$venueUuid/events/create': {
      id: '/gym/$venueUuid/events/create'
      path: '/events/create'
      fullPath: '/gym/$venueUuid/events/create'
      preLoaderRoute: typeof GymVenueUuidEventsCreateRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid': {
      id: '/gym/$venueUuid/events/$competitionUuid'
      path: '/events/$competitionUuid'
      fullPath: '/gym/$venueUuid/events/$competitionUuid'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/challenges/create': {
      id: '/gym/$venueUuid/challenges/create'
      path: '/challenges/create'
      fullPath: '/gym/$venueUuid/challenges/create'
      preLoaderRoute: typeof GymVenueUuidChallengesCreateRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid': {
      id: '/gym/$venueUuid/challenges/$challengeUuid'
      path: '/challenges/$challengeUuid'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/archive/$climbType': {
      id: '/gym/$venueUuid/archive/$climbType'
      path: '/archive/$climbType'
      fullPath: '/gym/$venueUuid/archive/$climbType'
      preLoaderRoute: typeof GymVenueUuidArchiveClimbTypeRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/settings/labels/': {
      id: '/gym/$venueUuid/settings/labels/'
      path: '/'
      fullPath: '/gym/$venueUuid/settings/labels/'
      preLoaderRoute: typeof GymVenueUuidSettingsLabelsIndexRouteImport
      parentRoute: typeof GymVenueUuidSettingsLabelsRoute
    }
    '/gym/$venueUuid/loyalty/quests/': {
      id: '/gym/$venueUuid/loyalty/quests/'
      path: '/quests'
      fullPath: '/gym/$venueUuid/loyalty/quests/'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsIndexRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/': {
      id: '/gym/$venueUuid/events/$competitionUuid/'
      path: '/'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidIndexRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/'
      path: '/'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidIndexRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidRoute
    }
    '/gym/$venueUuid/settings/targets/$climbType': {
      id: '/gym/$venueUuid/settings/targets/$climbType'
      path: '/targets/$climbType'
      fullPath: '/gym/$venueUuid/settings/targets/$climbType'
      preLoaderRoute: typeof GymVenueUuidSettingsTargetsClimbTypeRouteImport
      parentRoute: typeof GymVenueUuidSettingsRoute
    }
    '/gym/$venueUuid/settings/lines/create': {
      id: '/gym/$venueUuid/settings/lines/create'
      path: '/create'
      fullPath: '/gym/$venueUuid/settings/lines/create'
      preLoaderRoute: typeof GymVenueUuidSettingsLinesCreateRouteImport
      parentRoute: typeof GymVenueUuidSettingsLinesRoute
    }
    '/gym/$venueUuid/settings/lines/$lineUuid': {
      id: '/gym/$venueUuid/settings/lines/$lineUuid'
      path: '/$lineUuid'
      fullPath: '/gym/$venueUuid/settings/lines/$lineUuid'
      preLoaderRoute: typeof GymVenueUuidSettingsLinesLineUuidRouteImport
      parentRoute: typeof GymVenueUuidSettingsLinesRoute
    }
    '/gym/$venueUuid/settings/labels/archive': {
      id: '/gym/$venueUuid/settings/labels/archive'
      path: '/archive'
      fullPath: '/gym/$venueUuid/settings/labels/archive'
      preLoaderRoute: typeof GymVenueUuidSettingsLabelsArchiveRouteImport
      parentRoute: typeof GymVenueUuidSettingsLabelsRoute
    }
    '/gym/$venueUuid/schedule/set/$setUuid': {
      id: '/gym/$venueUuid/schedule/set/$setUuid'
      path: '/set/$setUuid'
      fullPath: '/gym/$venueUuid/schedule/set/$setUuid'
      preLoaderRoute: typeof GymVenueUuidScheduleSetSetUuidRouteImport
      parentRoute: typeof GymVenueUuidScheduleRoute
    }
    '/gym/$venueUuid/routes/$climbType/create': {
      id: '/gym/$venueUuid/routes/$climbType/create'
      path: '/create'
      fullPath: '/gym/$venueUuid/routes/$climbType/create'
      preLoaderRoute: typeof GymVenueUuidRoutesClimbTypeCreateRouteImport
      parentRoute: typeof GymVenueUuidRoutesClimbTypeRoute
    }
    '/gym/$venueUuid/loyalty/rewards/create': {
      id: '/gym/$venueUuid/loyalty/rewards/create'
      path: '/create'
      fullPath: '/gym/$venueUuid/loyalty/rewards/create'
      preLoaderRoute: typeof GymVenueUuidLoyaltyRewardsCreateRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRewardsRoute
    }
    '/gym/$venueUuid/loyalty/rewards/$rewardUuid': {
      id: '/gym/$venueUuid/loyalty/rewards/$rewardUuid'
      path: '/$rewardUuid'
      fullPath: '/gym/$venueUuid/loyalty/rewards/$rewardUuid'
      preLoaderRoute: typeof GymVenueUuidLoyaltyRewardsRewardUuidRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRewardsRoute
    }
    '/gym/$venueUuid/loyalty/quests/create': {
      id: '/gym/$venueUuid/loyalty/quests/create'
      path: '/quests/create'
      fullPath: '/gym/$venueUuid/loyalty/quests/create'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsCreateRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid'
      path: '/quests/$questUuid'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyRoute
    }
    '/gym/$venueUuid/loyalty/accounts/$accountUuid': {
      id: '/gym/$venueUuid/loyalty/accounts/$accountUuid'
      path: '/$accountUuid'
      fullPath: '/gym/$venueUuid/loyalty/accounts/$accountUuid'
      preLoaderRoute: typeof GymVenueUuidLoyaltyAccountsAccountUuidRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyAccountsRoute
    }
    '/gym/$venueUuid/events/series/create': {
      id: '/gym/$venueUuid/events/series/create'
      path: '/events/series/create'
      fullPath: '/gym/$venueUuid/events/series/create'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesCreateRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid': {
      id: '/gym/$venueUuid/events/series/$leagueUuid'
      path: '/events/series/$leagueUuid'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidRouteImport
      parentRoute: typeof GymVenueUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/tools': {
      id: '/gym/$venueUuid/events/$competitionUuid/tools'
      path: '/tools'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/tools'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidToolsRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/routes': {
      id: '/gym/$venueUuid/events/$competitionUuid/routes'
      path: '/routes'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/routes'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidRoutesRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/profile': {
      id: '/gym/$venueUuid/events/$competitionUuid/profile'
      path: '/profile'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/profile'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/competitors': {
      id: '/gym/$venueUuid/events/$competitionUuid/competitors'
      path: '/competitors'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/competitors'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/tools': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/tools'
      path: '/tools'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/tools'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidToolsRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/profile': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/profile'
      path: '/profile'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/profile'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/entries': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/entries'
      path: '/entries'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/entries'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidEntriesRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/'
      path: '/'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidIndexRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/'
      path: '/'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidIndexRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/profile/': {
      id: '/gym/$venueUuid/events/$competitionUuid/profile/'
      path: '/'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/profile/'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidProfileIndexRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/profile/': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/profile/'
      path: '/'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/profile/'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidProfileIndexRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRoute
    }
    '/gym/$venueUuid/settings/targets/$climbType/$targetUuid': {
      id: '/gym/$venueUuid/settings/targets/$climbType/$targetUuid'
      path: '/$targetUuid'
      fullPath: '/gym/$venueUuid/settings/targets/$climbType/$targetUuid'
      preLoaderRoute: typeof GymVenueUuidSettingsTargetsClimbTypeTargetUuidRouteImport
      parentRoute: typeof GymVenueUuidSettingsTargetsClimbTypeRoute
    }
    '/gym/$venueUuid/schedule/set/$setUuid/edit': {
      id: '/gym/$venueUuid/schedule/set/$setUuid/edit'
      path: '/edit'
      fullPath: '/gym/$venueUuid/schedule/set/$setUuid/edit'
      preLoaderRoute: typeof GymVenueUuidScheduleSetSetUuidEditRouteImport
      parentRoute: typeof GymVenueUuidScheduleSetSetUuidRoute
    }
    '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid': {
      id: '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid'
      path: '/$taskUuid'
      fullPath: '/gym/$venueUuid/schedule/set/$setUuid/$taskUuid'
      preLoaderRoute: typeof GymVenueUuidScheduleSetSetUuidTaskUuidRouteImport
      parentRoute: typeof GymVenueUuidScheduleSetSetUuidRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/entries': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/entries'
      path: '/entries'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/entries'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/profile': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/profile'
      path: '/profile'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/profile'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/competitors': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/competitors'
      path: '/competitors'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/competitors'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid': {
      id: '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid'
      path: '/$routeUuid'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/routes/$routeUuid'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidRoutesRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/profile/scoring': {
      id: '/gym/$venueUuid/events/$competitionUuid/profile/scoring'
      path: '/scoring'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/profile/scoring'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidProfileScoringRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/profile/details': {
      id: '/gym/$venueUuid/events/$competitionUuid/profile/details'
      path: '/details'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/profile/details'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidProfileDetailsRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/profile/circuits': {
      id: '/gym/$venueUuid/events/$competitionUuid/profile/circuits'
      path: '/circuits'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/profile/circuits'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidProfileCircuitsRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/profile/categories': {
      id: '/gym/$venueUuid/events/$competitionUuid/profile/categories'
      path: '/categories'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/profile/categories'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidProfileCategoriesRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/competitors/create': {
      id: '/gym/$venueUuid/events/$competitionUuid/competitors/create'
      path: '/create'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/competitors/create'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsCreateRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsRoute
    }
    '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid': {
      id: '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid'
      path: '/$userUuid'
      fullPath: '/gym/$venueUuid/events/$competitionUuid/competitors/$userUuid'
      preLoaderRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRouteImport
      parentRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/profile/rules': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/profile/rules'
      path: '/rules'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/profile/rules'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRulesRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion'
      path: '/promotion'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/profile/promotion'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidProfilePromotionRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/profile/details': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/profile/details'
      path: '/details'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/profile/details'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidProfileDetailsRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRoute
    }
    '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid': {
      id: '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid'
      path: '/$entryUuid'
      fullPath: '/gym/$venueUuid/challenges/$challengeUuid/entries/$entryUuid'
      preLoaderRoute: typeof GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRouteImport
      parentRoute: typeof GymVenueUuidChallengesChallengeUuidEntriesRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/profile/': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/'
      path: '/profile'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/profile/': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/profile/'
      path: '/'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/profile/'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileIndexRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules'
      path: '/profile/rules'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/rules'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion'
      path: '/profile/promotion'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/promotion'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details'
      path: '/profile/details'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/profile/details'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRoute
    }
    '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid': {
      id: '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid'
      path: '/$entryUuid'
      fullPath: '/gym/$venueUuid/loyalty/quests/$questUuid/entries/$entryUuid'
      preLoaderRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRouteImport
      parentRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring'
      path: '/scoring'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/profile/scoring'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileScoringRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/profile/details': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/profile/details'
      path: '/details'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/profile/details'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/profile/categories': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/profile/categories'
      path: '/categories'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/profile/categories'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileRoute
    }
    '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid': {
      id: '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid'
      path: '/$userUuid'
      fullPath: '/gym/$venueUuid/events/series/$leagueUuid/competitors/$userUuid'
      preLoaderRoute: typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRouteImport
      parentRoute: typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsRoute
    }
  }
}

interface GymVenueUuidLoyaltyAccountsRouteChildren {
  GymVenueUuidLoyaltyAccountsAccountUuidRoute: typeof GymVenueUuidLoyaltyAccountsAccountUuidRoute
}

const GymVenueUuidLoyaltyAccountsRouteChildren: GymVenueUuidLoyaltyAccountsRouteChildren =
  {
    GymVenueUuidLoyaltyAccountsAccountUuidRoute:
      GymVenueUuidLoyaltyAccountsAccountUuidRoute,
  }

const GymVenueUuidLoyaltyAccountsRouteWithChildren =
  GymVenueUuidLoyaltyAccountsRoute._addFileChildren(
    GymVenueUuidLoyaltyAccountsRouteChildren,
  )

interface GymVenueUuidLoyaltyRewardsRouteChildren {
  GymVenueUuidLoyaltyRewardsRewardUuidRoute: typeof GymVenueUuidLoyaltyRewardsRewardUuidRoute
  GymVenueUuidLoyaltyRewardsCreateRoute: typeof GymVenueUuidLoyaltyRewardsCreateRoute
}

const GymVenueUuidLoyaltyRewardsRouteChildren: GymVenueUuidLoyaltyRewardsRouteChildren =
  {
    GymVenueUuidLoyaltyRewardsRewardUuidRoute:
      GymVenueUuidLoyaltyRewardsRewardUuidRoute,
    GymVenueUuidLoyaltyRewardsCreateRoute:
      GymVenueUuidLoyaltyRewardsCreateRoute,
  }

const GymVenueUuidLoyaltyRewardsRouteWithChildren =
  GymVenueUuidLoyaltyRewardsRoute._addFileChildren(
    GymVenueUuidLoyaltyRewardsRouteChildren,
  )

interface GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteChildren {
  GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute
}

const GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteChildren: GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteChildren =
  {
    GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidEntriesEntryUuidRoute,
  }

const GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteWithChildren =
  GymVenueUuidLoyaltyQuestsQuestUuidEntriesRoute._addFileChildren(
    GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteChildren,
  )

interface GymVenueUuidLoyaltyQuestsQuestUuidRouteChildren {
  GymVenueUuidLoyaltyQuestsQuestUuidEntriesRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteWithChildren
  GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute
  GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute
  GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute
  GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute
  GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute
}

const GymVenueUuidLoyaltyQuestsQuestUuidRouteChildren: GymVenueUuidLoyaltyQuestsQuestUuidRouteChildren =
  {
    GymVenueUuidLoyaltyQuestsQuestUuidEntriesRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidEntriesRouteWithChildren,
    GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidIndexRoute,
    GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidProfileDetailsRoute,
    GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidProfilePromotionRoute,
    GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidProfileRulesRoute,
    GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute:
      GymVenueUuidLoyaltyQuestsQuestUuidProfileIndexRoute,
  }

const GymVenueUuidLoyaltyQuestsQuestUuidRouteWithChildren =
  GymVenueUuidLoyaltyQuestsQuestUuidRoute._addFileChildren(
    GymVenueUuidLoyaltyQuestsQuestUuidRouteChildren,
  )

interface GymVenueUuidLoyaltyRouteChildren {
  GymVenueUuidLoyaltyAccountsRoute: typeof GymVenueUuidLoyaltyAccountsRouteWithChildren
  GymVenueUuidLoyaltyRewardsRoute: typeof GymVenueUuidLoyaltyRewardsRouteWithChildren
  GymVenueUuidLoyaltyIndexRoute: typeof GymVenueUuidLoyaltyIndexRoute
  GymVenueUuidLoyaltyQuestsQuestUuidRoute: typeof GymVenueUuidLoyaltyQuestsQuestUuidRouteWithChildren
  GymVenueUuidLoyaltyQuestsCreateRoute: typeof GymVenueUuidLoyaltyQuestsCreateRoute
  GymVenueUuidLoyaltyQuestsIndexRoute: typeof GymVenueUuidLoyaltyQuestsIndexRoute
}

const GymVenueUuidLoyaltyRouteChildren: GymVenueUuidLoyaltyRouteChildren = {
  GymVenueUuidLoyaltyAccountsRoute:
    GymVenueUuidLoyaltyAccountsRouteWithChildren,
  GymVenueUuidLoyaltyRewardsRoute: GymVenueUuidLoyaltyRewardsRouteWithChildren,
  GymVenueUuidLoyaltyIndexRoute: GymVenueUuidLoyaltyIndexRoute,
  GymVenueUuidLoyaltyQuestsQuestUuidRoute:
    GymVenueUuidLoyaltyQuestsQuestUuidRouteWithChildren,
  GymVenueUuidLoyaltyQuestsCreateRoute: GymVenueUuidLoyaltyQuestsCreateRoute,
  GymVenueUuidLoyaltyQuestsIndexRoute: GymVenueUuidLoyaltyQuestsIndexRoute,
}

const GymVenueUuidLoyaltyRouteWithChildren =
  GymVenueUuidLoyaltyRoute._addFileChildren(GymVenueUuidLoyaltyRouteChildren)

interface GymVenueUuidRoutesClimbTypeRouteChildren {
  GymVenueUuidRoutesClimbTypeCreateRoute: typeof GymVenueUuidRoutesClimbTypeCreateRoute
}

const GymVenueUuidRoutesClimbTypeRouteChildren: GymVenueUuidRoutesClimbTypeRouteChildren =
  {
    GymVenueUuidRoutesClimbTypeCreateRoute:
      GymVenueUuidRoutesClimbTypeCreateRoute,
  }

const GymVenueUuidRoutesClimbTypeRouteWithChildren =
  GymVenueUuidRoutesClimbTypeRoute._addFileChildren(
    GymVenueUuidRoutesClimbTypeRouteChildren,
  )

interface GymVenueUuidRoutesRouteChildren {
  GymVenueUuidRoutesClimbTypeRoute: typeof GymVenueUuidRoutesClimbTypeRouteWithChildren
  GymVenueUuidRoutesIndexRoute: typeof GymVenueUuidRoutesIndexRoute
}

const GymVenueUuidRoutesRouteChildren: GymVenueUuidRoutesRouteChildren = {
  GymVenueUuidRoutesClimbTypeRoute:
    GymVenueUuidRoutesClimbTypeRouteWithChildren,
  GymVenueUuidRoutesIndexRoute: GymVenueUuidRoutesIndexRoute,
}

const GymVenueUuidRoutesRouteWithChildren =
  GymVenueUuidRoutesRoute._addFileChildren(GymVenueUuidRoutesRouteChildren)

interface GymVenueUuidScheduleSetSetUuidRouteChildren {
  GymVenueUuidScheduleSetSetUuidTaskUuidRoute: typeof GymVenueUuidScheduleSetSetUuidTaskUuidRoute
  GymVenueUuidScheduleSetSetUuidEditRoute: typeof GymVenueUuidScheduleSetSetUuidEditRoute
}

const GymVenueUuidScheduleSetSetUuidRouteChildren: GymVenueUuidScheduleSetSetUuidRouteChildren =
  {
    GymVenueUuidScheduleSetSetUuidTaskUuidRoute:
      GymVenueUuidScheduleSetSetUuidTaskUuidRoute,
    GymVenueUuidScheduleSetSetUuidEditRoute:
      GymVenueUuidScheduleSetSetUuidEditRoute,
  }

const GymVenueUuidScheduleSetSetUuidRouteWithChildren =
  GymVenueUuidScheduleSetSetUuidRoute._addFileChildren(
    GymVenueUuidScheduleSetSetUuidRouteChildren,
  )

interface GymVenueUuidScheduleRouteChildren {
  GymVenueUuidScheduleCalendarRoute: typeof GymVenueUuidScheduleCalendarRoute
  GymVenueUuidScheduleIndexRoute: typeof GymVenueUuidScheduleIndexRoute
  GymVenueUuidScheduleSetSetUuidRoute: typeof GymVenueUuidScheduleSetSetUuidRouteWithChildren
}

const GymVenueUuidScheduleRouteChildren: GymVenueUuidScheduleRouteChildren = {
  GymVenueUuidScheduleCalendarRoute: GymVenueUuidScheduleCalendarRoute,
  GymVenueUuidScheduleIndexRoute: GymVenueUuidScheduleIndexRoute,
  GymVenueUuidScheduleSetSetUuidRoute:
    GymVenueUuidScheduleSetSetUuidRouteWithChildren,
}

const GymVenueUuidScheduleRouteWithChildren =
  GymVenueUuidScheduleRoute._addFileChildren(GymVenueUuidScheduleRouteChildren)

interface GymVenueUuidSettingsLabelsRouteChildren {
  GymVenueUuidSettingsLabelsArchiveRoute: typeof GymVenueUuidSettingsLabelsArchiveRoute
  GymVenueUuidSettingsLabelsIndexRoute: typeof GymVenueUuidSettingsLabelsIndexRoute
}

const GymVenueUuidSettingsLabelsRouteChildren: GymVenueUuidSettingsLabelsRouteChildren =
  {
    GymVenueUuidSettingsLabelsArchiveRoute:
      GymVenueUuidSettingsLabelsArchiveRoute,
    GymVenueUuidSettingsLabelsIndexRoute: GymVenueUuidSettingsLabelsIndexRoute,
  }

const GymVenueUuidSettingsLabelsRouteWithChildren =
  GymVenueUuidSettingsLabelsRoute._addFileChildren(
    GymVenueUuidSettingsLabelsRouteChildren,
  )

interface GymVenueUuidSettingsLinesRouteChildren {
  GymVenueUuidSettingsLinesLineUuidRoute: typeof GymVenueUuidSettingsLinesLineUuidRoute
  GymVenueUuidSettingsLinesCreateRoute: typeof GymVenueUuidSettingsLinesCreateRoute
}

const GymVenueUuidSettingsLinesRouteChildren: GymVenueUuidSettingsLinesRouteChildren =
  {
    GymVenueUuidSettingsLinesLineUuidRoute:
      GymVenueUuidSettingsLinesLineUuidRoute,
    GymVenueUuidSettingsLinesCreateRoute: GymVenueUuidSettingsLinesCreateRoute,
  }

const GymVenueUuidSettingsLinesRouteWithChildren =
  GymVenueUuidSettingsLinesRoute._addFileChildren(
    GymVenueUuidSettingsLinesRouteChildren,
  )

interface GymVenueUuidSettingsTargetsClimbTypeRouteChildren {
  GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute: typeof GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute
}

const GymVenueUuidSettingsTargetsClimbTypeRouteChildren: GymVenueUuidSettingsTargetsClimbTypeRouteChildren =
  {
    GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute:
      GymVenueUuidSettingsTargetsClimbTypeTargetUuidRoute,
  }

const GymVenueUuidSettingsTargetsClimbTypeRouteWithChildren =
  GymVenueUuidSettingsTargetsClimbTypeRoute._addFileChildren(
    GymVenueUuidSettingsTargetsClimbTypeRouteChildren,
  )

interface GymVenueUuidSettingsRouteChildren {
  GymVenueUuidSettingsColorsRoute: typeof GymVenueUuidSettingsColorsRoute
  GymVenueUuidSettingsCreditsRoute: typeof GymVenueUuidSettingsCreditsRoute
  GymVenueUuidSettingsLabelsRoute: typeof GymVenueUuidSettingsLabelsRouteWithChildren
  GymVenueUuidSettingsLinesRoute: typeof GymVenueUuidSettingsLinesRouteWithChildren
  GymVenueUuidSettingsProfileRoute: typeof GymVenueUuidSettingsProfileRoute
  GymVenueUuidSettingsSectorsRoute: typeof GymVenueUuidSettingsSectorsRoute
  GymVenueUuidSettingsZonesRoute: typeof GymVenueUuidSettingsZonesRoute
  GymVenueUuidSettingsTargetsClimbTypeRoute: typeof GymVenueUuidSettingsTargetsClimbTypeRouteWithChildren
}

const GymVenueUuidSettingsRouteChildren: GymVenueUuidSettingsRouteChildren = {
  GymVenueUuidSettingsColorsRoute: GymVenueUuidSettingsColorsRoute,
  GymVenueUuidSettingsCreditsRoute: GymVenueUuidSettingsCreditsRoute,
  GymVenueUuidSettingsLabelsRoute: GymVenueUuidSettingsLabelsRouteWithChildren,
  GymVenueUuidSettingsLinesRoute: GymVenueUuidSettingsLinesRouteWithChildren,
  GymVenueUuidSettingsProfileRoute: GymVenueUuidSettingsProfileRoute,
  GymVenueUuidSettingsSectorsRoute: GymVenueUuidSettingsSectorsRoute,
  GymVenueUuidSettingsZonesRoute: GymVenueUuidSettingsZonesRoute,
  GymVenueUuidSettingsTargetsClimbTypeRoute:
    GymVenueUuidSettingsTargetsClimbTypeRouteWithChildren,
}

const GymVenueUuidSettingsRouteWithChildren =
  GymVenueUuidSettingsRoute._addFileChildren(GymVenueUuidSettingsRouteChildren)

interface GymVenueUuidStaffRouteChildren {
  GymVenueUuidStaffUserUuidRoute: typeof GymVenueUuidStaffUserUuidRoute
  GymVenueUuidStaffAddRoute: typeof GymVenueUuidStaffAddRoute
}

const GymVenueUuidStaffRouteChildren: GymVenueUuidStaffRouteChildren = {
  GymVenueUuidStaffUserUuidRoute: GymVenueUuidStaffUserUuidRoute,
  GymVenueUuidStaffAddRoute: GymVenueUuidStaffAddRoute,
}

const GymVenueUuidStaffRouteWithChildren =
  GymVenueUuidStaffRoute._addFileChildren(GymVenueUuidStaffRouteChildren)

interface GymVenueUuidChallengesChallengeUuidEntriesRouteChildren {
  GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute: typeof GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute
}

const GymVenueUuidChallengesChallengeUuidEntriesRouteChildren: GymVenueUuidChallengesChallengeUuidEntriesRouteChildren =
  {
    GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute:
      GymVenueUuidChallengesChallengeUuidEntriesEntryUuidRoute,
  }

const GymVenueUuidChallengesChallengeUuidEntriesRouteWithChildren =
  GymVenueUuidChallengesChallengeUuidEntriesRoute._addFileChildren(
    GymVenueUuidChallengesChallengeUuidEntriesRouteChildren,
  )

interface GymVenueUuidChallengesChallengeUuidProfileRouteChildren {
  GymVenueUuidChallengesChallengeUuidProfileDetailsRoute: typeof GymVenueUuidChallengesChallengeUuidProfileDetailsRoute
  GymVenueUuidChallengesChallengeUuidProfilePromotionRoute: typeof GymVenueUuidChallengesChallengeUuidProfilePromotionRoute
  GymVenueUuidChallengesChallengeUuidProfileRulesRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRulesRoute
  GymVenueUuidChallengesChallengeUuidProfileIndexRoute: typeof GymVenueUuidChallengesChallengeUuidProfileIndexRoute
}

const GymVenueUuidChallengesChallengeUuidProfileRouteChildren: GymVenueUuidChallengesChallengeUuidProfileRouteChildren =
  {
    GymVenueUuidChallengesChallengeUuidProfileDetailsRoute:
      GymVenueUuidChallengesChallengeUuidProfileDetailsRoute,
    GymVenueUuidChallengesChallengeUuidProfilePromotionRoute:
      GymVenueUuidChallengesChallengeUuidProfilePromotionRoute,
    GymVenueUuidChallengesChallengeUuidProfileRulesRoute:
      GymVenueUuidChallengesChallengeUuidProfileRulesRoute,
    GymVenueUuidChallengesChallengeUuidProfileIndexRoute:
      GymVenueUuidChallengesChallengeUuidProfileIndexRoute,
  }

const GymVenueUuidChallengesChallengeUuidProfileRouteWithChildren =
  GymVenueUuidChallengesChallengeUuidProfileRoute._addFileChildren(
    GymVenueUuidChallengesChallengeUuidProfileRouteChildren,
  )

interface GymVenueUuidChallengesChallengeUuidRouteChildren {
  GymVenueUuidChallengesChallengeUuidEntriesRoute: typeof GymVenueUuidChallengesChallengeUuidEntriesRouteWithChildren
  GymVenueUuidChallengesChallengeUuidProfileRoute: typeof GymVenueUuidChallengesChallengeUuidProfileRouteWithChildren
  GymVenueUuidChallengesChallengeUuidToolsRoute: typeof GymVenueUuidChallengesChallengeUuidToolsRoute
  GymVenueUuidChallengesChallengeUuidIndexRoute: typeof GymVenueUuidChallengesChallengeUuidIndexRoute
}

const GymVenueUuidChallengesChallengeUuidRouteChildren: GymVenueUuidChallengesChallengeUuidRouteChildren =
  {
    GymVenueUuidChallengesChallengeUuidEntriesRoute:
      GymVenueUuidChallengesChallengeUuidEntriesRouteWithChildren,
    GymVenueUuidChallengesChallengeUuidProfileRoute:
      GymVenueUuidChallengesChallengeUuidProfileRouteWithChildren,
    GymVenueUuidChallengesChallengeUuidToolsRoute:
      GymVenueUuidChallengesChallengeUuidToolsRoute,
    GymVenueUuidChallengesChallengeUuidIndexRoute:
      GymVenueUuidChallengesChallengeUuidIndexRoute,
  }

const GymVenueUuidChallengesChallengeUuidRouteWithChildren =
  GymVenueUuidChallengesChallengeUuidRoute._addFileChildren(
    GymVenueUuidChallengesChallengeUuidRouteChildren,
  )

interface GymVenueUuidEventsCompetitionUuidCompetitorsRouteChildren {
  GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute
  GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute
}

const GymVenueUuidEventsCompetitionUuidCompetitorsRouteChildren: GymVenueUuidEventsCompetitionUuidCompetitorsRouteChildren =
  {
    GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute:
      GymVenueUuidEventsCompetitionUuidCompetitorsUserUuidRoute,
    GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute:
      GymVenueUuidEventsCompetitionUuidCompetitorsCreateRoute,
  }

const GymVenueUuidEventsCompetitionUuidCompetitorsRouteWithChildren =
  GymVenueUuidEventsCompetitionUuidCompetitorsRoute._addFileChildren(
    GymVenueUuidEventsCompetitionUuidCompetitorsRouteChildren,
  )

interface GymVenueUuidEventsCompetitionUuidProfileRouteChildren {
  GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute: typeof GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute
  GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute: typeof GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute
  GymVenueUuidEventsCompetitionUuidProfileDetailsRoute: typeof GymVenueUuidEventsCompetitionUuidProfileDetailsRoute
  GymVenueUuidEventsCompetitionUuidProfileScoringRoute: typeof GymVenueUuidEventsCompetitionUuidProfileScoringRoute
  GymVenueUuidEventsCompetitionUuidProfileIndexRoute: typeof GymVenueUuidEventsCompetitionUuidProfileIndexRoute
}

const GymVenueUuidEventsCompetitionUuidProfileRouteChildren: GymVenueUuidEventsCompetitionUuidProfileRouteChildren =
  {
    GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute:
      GymVenueUuidEventsCompetitionUuidProfileCategoriesRoute,
    GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute:
      GymVenueUuidEventsCompetitionUuidProfileCircuitsRoute,
    GymVenueUuidEventsCompetitionUuidProfileDetailsRoute:
      GymVenueUuidEventsCompetitionUuidProfileDetailsRoute,
    GymVenueUuidEventsCompetitionUuidProfileScoringRoute:
      GymVenueUuidEventsCompetitionUuidProfileScoringRoute,
    GymVenueUuidEventsCompetitionUuidProfileIndexRoute:
      GymVenueUuidEventsCompetitionUuidProfileIndexRoute,
  }

const GymVenueUuidEventsCompetitionUuidProfileRouteWithChildren =
  GymVenueUuidEventsCompetitionUuidProfileRoute._addFileChildren(
    GymVenueUuidEventsCompetitionUuidProfileRouteChildren,
  )

interface GymVenueUuidEventsCompetitionUuidRoutesRouteChildren {
  GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute: typeof GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute
}

const GymVenueUuidEventsCompetitionUuidRoutesRouteChildren: GymVenueUuidEventsCompetitionUuidRoutesRouteChildren =
  {
    GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute:
      GymVenueUuidEventsCompetitionUuidRoutesRouteUuidRoute,
  }

const GymVenueUuidEventsCompetitionUuidRoutesRouteWithChildren =
  GymVenueUuidEventsCompetitionUuidRoutesRoute._addFileChildren(
    GymVenueUuidEventsCompetitionUuidRoutesRouteChildren,
  )

interface GymVenueUuidEventsCompetitionUuidRouteChildren {
  GymVenueUuidEventsCompetitionUuidCompetitorsRoute: typeof GymVenueUuidEventsCompetitionUuidCompetitorsRouteWithChildren
  GymVenueUuidEventsCompetitionUuidProfileRoute: typeof GymVenueUuidEventsCompetitionUuidProfileRouteWithChildren
  GymVenueUuidEventsCompetitionUuidRoutesRoute: typeof GymVenueUuidEventsCompetitionUuidRoutesRouteWithChildren
  GymVenueUuidEventsCompetitionUuidToolsRoute: typeof GymVenueUuidEventsCompetitionUuidToolsRoute
  GymVenueUuidEventsCompetitionUuidIndexRoute: typeof GymVenueUuidEventsCompetitionUuidIndexRoute
}

const GymVenueUuidEventsCompetitionUuidRouteChildren: GymVenueUuidEventsCompetitionUuidRouteChildren =
  {
    GymVenueUuidEventsCompetitionUuidCompetitorsRoute:
      GymVenueUuidEventsCompetitionUuidCompetitorsRouteWithChildren,
    GymVenueUuidEventsCompetitionUuidProfileRoute:
      GymVenueUuidEventsCompetitionUuidProfileRouteWithChildren,
    GymVenueUuidEventsCompetitionUuidRoutesRoute:
      GymVenueUuidEventsCompetitionUuidRoutesRouteWithChildren,
    GymVenueUuidEventsCompetitionUuidToolsRoute:
      GymVenueUuidEventsCompetitionUuidToolsRoute,
    GymVenueUuidEventsCompetitionUuidIndexRoute:
      GymVenueUuidEventsCompetitionUuidIndexRoute,
  }

const GymVenueUuidEventsCompetitionUuidRouteWithChildren =
  GymVenueUuidEventsCompetitionUuidRoute._addFileChildren(
    GymVenueUuidEventsCompetitionUuidRouteChildren,
  )

interface GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteChildren {
  GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute: typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute
}

const GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteChildren: GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteChildren =
  {
    GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute:
      GymVenueUuidEventsSeriesLeagueUuidCompetitorsUserUuidRoute,
  }

const GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteWithChildren =
  GymVenueUuidEventsSeriesLeagueUuidCompetitorsRoute._addFileChildren(
    GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteChildren,
  )

interface GymVenueUuidEventsSeriesLeagueUuidProfileRouteChildren {
  GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute
  GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute
  GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute
  GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute
}

const GymVenueUuidEventsSeriesLeagueUuidProfileRouteChildren: GymVenueUuidEventsSeriesLeagueUuidProfileRouteChildren =
  {
    GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute:
      GymVenueUuidEventsSeriesLeagueUuidProfileCategoriesRoute,
    GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute:
      GymVenueUuidEventsSeriesLeagueUuidProfileDetailsRoute,
    GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute:
      GymVenueUuidEventsSeriesLeagueUuidProfileScoringRoute,
    GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute:
      GymVenueUuidEventsSeriesLeagueUuidProfileIndexRoute,
  }

const GymVenueUuidEventsSeriesLeagueUuidProfileRouteWithChildren =
  GymVenueUuidEventsSeriesLeagueUuidProfileRoute._addFileChildren(
    GymVenueUuidEventsSeriesLeagueUuidProfileRouteChildren,
  )

interface GymVenueUuidEventsSeriesLeagueUuidRouteChildren {
  GymVenueUuidEventsSeriesLeagueUuidCompetitorsRoute: typeof GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteWithChildren
  GymVenueUuidEventsSeriesLeagueUuidProfileRoute: typeof GymVenueUuidEventsSeriesLeagueUuidProfileRouteWithChildren
  GymVenueUuidEventsSeriesLeagueUuidIndexRoute: typeof GymVenueUuidEventsSeriesLeagueUuidIndexRoute
}

const GymVenueUuidEventsSeriesLeagueUuidRouteChildren: GymVenueUuidEventsSeriesLeagueUuidRouteChildren =
  {
    GymVenueUuidEventsSeriesLeagueUuidCompetitorsRoute:
      GymVenueUuidEventsSeriesLeagueUuidCompetitorsRouteWithChildren,
    GymVenueUuidEventsSeriesLeagueUuidProfileRoute:
      GymVenueUuidEventsSeriesLeagueUuidProfileRouteWithChildren,
    GymVenueUuidEventsSeriesLeagueUuidIndexRoute:
      GymVenueUuidEventsSeriesLeagueUuidIndexRoute,
  }

const GymVenueUuidEventsSeriesLeagueUuidRouteWithChildren =
  GymVenueUuidEventsSeriesLeagueUuidRoute._addFileChildren(
    GymVenueUuidEventsSeriesLeagueUuidRouteChildren,
  )

interface GymVenueUuidRouteChildren {
  GymVenueUuidLoyaltyRoute: typeof GymVenueUuidLoyaltyRouteWithChildren
  GymVenueUuidRoutesRoute: typeof GymVenueUuidRoutesRouteWithChildren
  GymVenueUuidScheduleRoute: typeof GymVenueUuidScheduleRouteWithChildren
  GymVenueUuidSettingsRoute: typeof GymVenueUuidSettingsRouteWithChildren
  GymVenueUuidStaffRoute: typeof GymVenueUuidStaffRouteWithChildren
  GymVenueUuidIndexRoute: typeof GymVenueUuidIndexRoute
  GymVenueUuidArchiveClimbTypeRoute: typeof GymVenueUuidArchiveClimbTypeRoute
  GymVenueUuidChallengesChallengeUuidRoute: typeof GymVenueUuidChallengesChallengeUuidRouteWithChildren
  GymVenueUuidChallengesCreateRoute: typeof GymVenueUuidChallengesCreateRoute
  GymVenueUuidEventsCompetitionUuidRoute: typeof GymVenueUuidEventsCompetitionUuidRouteWithChildren
  GymVenueUuidEventsCreateRoute: typeof GymVenueUuidEventsCreateRoute
  GymVenueUuidArchiveIndexRoute: typeof GymVenueUuidArchiveIndexRoute
  GymVenueUuidChallengesIndexRoute: typeof GymVenueUuidChallengesIndexRoute
  GymVenueUuidEventsIndexRoute: typeof GymVenueUuidEventsIndexRoute
  GymVenueUuidEventsSeriesLeagueUuidRoute: typeof GymVenueUuidEventsSeriesLeagueUuidRouteWithChildren
  GymVenueUuidEventsSeriesCreateRoute: typeof GymVenueUuidEventsSeriesCreateRoute
}

const GymVenueUuidRouteChildren: GymVenueUuidRouteChildren = {
  GymVenueUuidLoyaltyRoute: GymVenueUuidLoyaltyRouteWithChildren,
  GymVenueUuidRoutesRoute: GymVenueUuidRoutesRouteWithChildren,
  GymVenueUuidScheduleRoute: GymVenueUuidScheduleRouteWithChildren,
  GymVenueUuidSettingsRoute: GymVenueUuidSettingsRouteWithChildren,
  GymVenueUuidStaffRoute: GymVenueUuidStaffRouteWithChildren,
  GymVenueUuidIndexRoute: GymVenueUuidIndexRoute,
  GymVenueUuidArchiveClimbTypeRoute: GymVenueUuidArchiveClimbTypeRoute,
  GymVenueUuidChallengesChallengeUuidRoute:
    GymVenueUuidChallengesChallengeUuidRouteWithChildren,
  GymVenueUuidChallengesCreateRoute: GymVenueUuidChallengesCreateRoute,
  GymVenueUuidEventsCompetitionUuidRoute:
    GymVenueUuidEventsCompetitionUuidRouteWithChildren,
  GymVenueUuidEventsCreateRoute: GymVenueUuidEventsCreateRoute,
  GymVenueUuidArchiveIndexRoute: GymVenueUuidArchiveIndexRoute,
  GymVenueUuidChallengesIndexRoute: GymVenueUuidChallengesIndexRoute,
  GymVenueUuidEventsIndexRoute: GymVenueUuidEventsIndexRoute,
  GymVenueUuidEventsSeriesLeagueUuidRoute:
    GymVenueUuidEventsSeriesLeagueUuidRouteWithChildren,
  GymVenueUuidEventsSeriesCreateRoute: GymVenueUuidEventsSeriesCreateRoute,
}

const GymVenueUuidRouteWithChildren = GymVenueUuidRoute._addFileChildren(
  GymVenueUuidRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  GymVenueUuidRoute: GymVenueUuidRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
